import styled, { css } from 'styled-components';
import Link from 'gatsby-link';
import PropTypes from 'prop-types';

import { SCREEN } from '../../assets/styles/constants';
import { baseText } from '../../assets/styles/text';
import { buttonFill, buttonOutline } from '../../assets/styles/button';

const smallerButtonCss = css`
	font-size: 18px;
	padding: 10px 30px;
`;

const buttonCss = css`
	${baseText};
	position: relative;
	text-decoration: none;
	color: #FFFFFF;
	width: auto;
	border-radius: 3px;
	display: inline-block;
	transition: all 0.2s ease-in-out;
	text-align: center;
	white-space: nowrap;

	${props => (props.smaller ? smallerButtonCss : 'padding: 15px 50px')};
	
	${SCREEN.MEDIUM} {
		font-size: 18px;
		padding: 15px 0;
		max-width: 100%;	
		width: 100%;
	}
`;

const greenButtonCss = css`
	background-color: #1FA59A;
	color: white;

	&:hover {
		background-color: #1B8B82;
	}
`;

export const purpleButtonCss = css`
	background-color: #7F84FF;
	color: white;

	&:hover {
		background-color: #696dd9;
		cursor:pointer;
	}
`;

export const PurpleButton = styled(Link)`
	${buttonCss};
	${purpleButtonCss};
	&:hover {
		cursor:pointer;
	}
`;

export const PurpleButtonExternalLink = styled.a`
	${buttonCss};
	${purpleButtonCss};
`;

export const GreenButton = styled(Link)`
	${buttonCss};
	${greenButtonCss};
`;

export const GreenButtonExternalLink = styled.a`
	${buttonCss};
	${greenButtonCss};
`;

export const FakeGreenButton = styled.div`
	${buttonCss};
	${greenButtonCss};
	
	${SCREEN.MEDIUM} {
		font-size: 16px;
		padding: 10px 0px;
	}
`;

export const SubmitButton = styled.button`
	${buttonCss};
	${greenButtonCss};
	font-size: 14px;
	padding: 12px 80px;
	margin: auto;
`;

export const Button = styled.button`
	${(props) => {
		switch (props.type) {
		case 'fill': {
			return buttonFill;
		}
		case 'outline': {
			return buttonOutline;
		}
		default: {
			return buttonFill;
		}
		}
	}};
`;

Button.defaultProps = {
	size: 'standard',
	type: 'fill',
	fontSize: 'h5',
	background: 'rgba(147,228,182,1)',
	gradient: 'rgba(104,211,151,1)',
	border_color: 'rgba(147,228,182,1)',
};

Button.propTypes = {
	/**
	 * Defines the height and the padding of the button
	 */
	size: PropTypes.oneOf(['small', 'standard', 'large']),
	/**
	 * Defines the type of the button
	 */
	type: PropTypes.oneOf(['fill', 'outline']),
	fontSize: PropTypes.oneOf(['base', 'base_mobile', 'read', 'caption', 'tag', 'h1', 'h1_mobile', 'h2', 'h2_mobile', 'h3', 'h4', 'h5']),
	fontWeight: PropTypes.oneOf(['normal', '600', '800']),
};
